import React, { Component } from 'react';
import YouTube from 'react-youtube';
import $ from 'jquery';
import { connect } from 'react-redux';
import { appendScript } from '../../../../utils/appendScript';
import {
	setPrevVideoId,
	checkVideo,
} from '../../../../redux/testPage/testPage.actions';
import { setErrorMsg } from '../../../../redux/utilities/utils.actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';

var mytimer;
class Video extends Component {
	constructor(props) {
		super(props);
		this.state = {
			hideVideo: false,
			replayCount: '',
			playerTimeDifference: 0,
			player: null,
			playing: false,
		};

		this.OnVideoStateChange = this.OnVideoStateChange.bind(this);
		this.playerPause = this.playerPause.bind(this);
		this.playerEnd = this.playerEnd.bind(this);
		this.set_youtube = this.set_youtube.bind(this);
		this.maxVideoPlayCountReached = this.maxVideoPlayCountReached.bind(this);
		this.playerReady = this.playerReady.bind(this);
		this.checkInternet = this.checkInternet.bind(this);
		this.formatTime = this.formatTime.bind(this);
		this.changeTime = this.changeTime.bind(this);
		this.customSeek = this.customSeek.bind(this);
	}

	checkInternet() {
		const {
			currentAttemptId,
			questionId,
			videoId,
			checkVideo,
			setErrorMsg,
		} = this.props;

		if (!window.navigator.onLine) {
			alert(
				'We are unable to proceed with the test as you are offline. Make sure your Wi-Fi or mobile data is turned on and try again.',
			);
		} else if (navigator.connection.downlink * 1000 < 400) {
			setErrorMsg(
				'Your internet speed is low. Please change your network and try again.',
			);
		} else {
			checkVideo(currentAttemptId, questionId, videoId);
		}
	}

	maxVideoPlayCountReached() {
		let overlayEl = document.getElementById('restrictReplay');
		overlayEl.style.display = 'block';
		let container = document.getElementById('videoContainer');
		container.style.pointerEvents = 'none';
	}

	OnVideoStateChange(event) {
		const { youtubeEnd } = this.props;
		switch (event.data) {
			case -1: // unstarted
				// reset everything
				localStorage.setItem('karaokeStartTime', Date.now());
				console.log('unstarted');
				localStorage.removeItem('totalBufferTime');
				break;
			case 1: // playing
				// stop seeding for buffer
				this.setState({ playing: true });
				const self = this;
				mytimer = setInterval(function () {
					const playerCurrentTime = event.target.getCurrentTime();
					const playerTotalTime = youtubeEnd || event.target.getDuration();
					const playerTimeDifference = (playerCurrentTime / playerTotalTime) * 100;

					self.setState({ playerTimeDifference });
					//document.getElementsByClassName("percentage")[1].style.width = `${playerTimeDifference}%`
					if (!!document.getElementById('startTime')) {
						document.getElementById('startTime').innerHTML = self.formatTime(
							playerCurrentTime,
						);
					}
					if (!!document.getElementById('endTime')) {
						document.getElementById('endTime').innerHTML = self.formatTime(
							playerTotalTime,
						);
					}
				}, 1000);

				if (localStorage.getItem('karaokebufferTime') !== null) {
					var oldbufferTime = localStorage.getItem('totalBufferTime');
					var newbufferTime;
					if (oldbufferTime != null) {
						newbufferTime = Math.round(
							parseInt(oldbufferTime, 10) +
								(Date.now() - localStorage.getItem('karaokebufferTime')) / 1000,
						);
					} else {
						newbufferTime = Math.round(
							(Date.now() - localStorage.getItem('karaokebufferTime')) / 1000,
						);
					}

					localStorage.setItem('totalBufferTime', newbufferTime);
					localStorage.removeItem('karaokebufferTime');
				}
				break;
			case 2:
				console.log('paused');
				this.setState({ playing: false });
				localStorage.setItem('karaokebufferTime', Date.now());
				break;
			case 3: // buffering
				// start buffer seeding
				console.log('buffering');
				localStorage.setItem('karaokebufferTime', Date.now());
				break;
			default:
				clearTimeout(mytimer);
				this.setState({ playing: false });
				break;
		}
	}

	customSeek(e) {
		e.preventDefault();
		if (!!this.state.player) {
			this.state.player.pauseVideo();
			let offset = $('.youtube-line-progress').offset().left;
			let left = e.pageX - offset;
			let totalWidth = $('.youtube-line-progress').width();
			let percentage = left / totalWidth;
			let vidTime = parseInt(
				(this.props.youtubeEnd || this.state.player.getDuration()) * percentage,
			);

			this.changeTime(vidTime);
		}
	}

	changeTime(seconds) {
		this.state.player.seekTo(seconds);
		this.state.player.playVideo();
	}

	playerPause() {
		console.log('pause');
	}

	playerEnd() {
		localStorage.setItem('isPauseTimer', false);
		appendScript('testpage');
		let replayCount = parseInt(this.state.replayCount, 10) - 1;
		this.setState({ replayCount });

		if (replayCount === 0) {
			this.maxVideoPlayCountReached();
		} else {
			this.setState({ hideVideo: true }, () => {
				this.setOverlayStyles();
			});
		}
	}

	componentWillUnmount() {
		localStorage.removeItem('totalBufferTime');
		window.removeEventListener('resize', this.playerReady);
	}

	playingstart() {
		console.log('Video Start');
		//localStorage.setItem('isPauseTimer', true);
	}

	componentDidMount(props) {
		const {
			prevVideoId,
			leftSectionProps: { videoReplayCount },
			videoId,
			vkDetails,
			youtubeStart,
			youtubeEnd,
		} = this.props;
		if (document.getElementById('startTime')) {
			document.getElementById('startTime').innerHTML = this.formatTime(
				youtubeStart,
			);
		}
		if (!!document.getElementById('endTime')) {
			document.getElementById('endTime').innerHTML = this.formatTime(youtubeEnd);
		}
		this.setState({ hideVideo: prevVideoId === videoId });

		this.setState({ replayCount: videoReplayCount });
		if (!!vkDetails && Object.entries(vkDetails) <= 0) {
			this.props.setPrevVideoId(videoId);
		}

		window.addEventListener('resize', this.playerReady);
	}
	set_youtube() {
		const { youtubeStart } = this.props;
		this.setState({ hideVideo: false });
		if (!!this.state.player) {
			this.state.player.seekTo(youtubeStart);
			this.state.player.playVideo();
		}
	}
	setOverlayStyles = () => {
		let youtube = document.getElementById('react-youtube-Id');
		let overlayContainer = document.getElementById('overlayContainer');

		if (!!youtube) {
			let overlay = document.getElementById('overlay');
			let progress = document.getElementsByClassName('youtube-line-progress')[0];
			progress.style.width = `${youtube.width}px`;

			if (!!overlay) {
				overlay.style.height = `${overlayContainer.height}px`;
				overlay.style.width = `${youtube.width}px`;
				overlay.style.top = `${youtube.offsetTop}px`;
				overlay.style.left = `${youtube.offsetLeft}px`;
			}
		}
	};

	playerReady(event) {
		this.setOverlayStyles();
		this.setState({
			player: event.target,
		});
	}

	formatTime(seconds) {
		return (
			`${parseInt(seconds / 60) || '00'}`.padStart(2, '0') +
			':' +
			`${parseInt(seconds % 60) || '00'}`.padStart(2, '0')
		);
	}

	render() {
		const { hideVideo, player, playing } = this.state;

		const {
			leftSectionProps: { youtubeStart, youtubeEnd, qtype, jwPlayerId, questionId },
			queDesc,
			videoId,
			elementType,
		} = this.props;
		const opts = {
			playerVars: {
				autoplay: 0,
				start: youtubeStart,
				end: youtubeEnd,
				controls: 0,
				disablekb: 1,
				fs: 0,
				showinfo: 0,
				loop: 1,
				rel: 0,
				listType: 'playlist',
				modestbranding: 1,
			},
		};
		const orgID = Number(localStorage.getItem("orgID"));
		const jwOrgIds = [107,4655,4654,4597,4596,4594,4593,4595,4598];
		const gcpOrgs = [5054,5138]
		const JWresult = jwOrgIds.includes(orgID);
		const Cloudresult = gcpOrgs.includes(orgID);
		return (
			<div>
				<div id="videoContainer">
					<div id="overlayContainer">
						{hideVideo && !jwPlayerId &&
							<div key={questionId} id="overlay" onClick={this.set_youtube}>
								<div id="replayButton">
									<i className="fa fa-undo"></i> Replay
								</div>
							</div>
						 }

						{jwPlayerId ? (
							  Cloudresult ? (
							    <iframe
							      id="player"
							      frameborder="0"
							      allowfullscreen="1"
							      width="500"
							      height="250"
							      title="Cloud video player"
							      src={`https://storage.googleapis.com/stepvideos/${jwPlayerId}.mp4`}
							    ></iframe>
							  ) : (
							    <iframe
							      id="player"
							      frameborder="0"
							      allowfullscreen="1"
							      width="500"
							      height="250"
							      title="YouTube video player"
							      src={`https://cdn.jwplayer.com/videos/${jwPlayerId}-Dnlxi9RE.mp4`}
							    ></iframe>
							  )
							) : (
							  <YouTube
							    videoId={videoId}
							    opts={opts}
							    currentTime={new Date().getTime()}
							    onPause={this.playerPause}
							    onEnd={this.playerEnd}
							    onPlay={this.playingstart}
							    onReady={this.playerReady}
							    id={'react-youtube-Id'}
							    onStateChange={(e) => {
							      this.OnVideoStateChange(e);
							    }}
							  />
							)}


						<span
							style={{
								pointerEvents: hideVideo ? 'none' : 'auto',
								display: elementType === 'W' && qtype !== 'VK' ? 'block' : 'none',
							}}
						>
							<span className="youtube-line-progress" onClick={this.customSeek}>
								<span
									className="percentage"
									style={{ width: `${this.state.playerTimeDifference}%` }}
								></span>
							</span>
							<span className="YTcontrols">
								{!playing ? (
									<FontAwesomeIcon
										onClick={() => player.playVideo()}
										icon={faPlay}
										size="lg"
									/>
								) : (
									<FontAwesomeIcon
										onClick={() => player.pauseVideo()}
										icon={faPause}
										size="lg"
									/>
								)}
								<span id="startTime" style={{ marginLeft: '10px' }}></span>/
								<span id="endTime"></span>
							</span>
						</span>

						<span className="video-error">
							If the video is not loading,
							<span
								style={{ cursor: 'pointer' }}
								id="videocheck"
								className="divAsAnchor"
								onClick={() => {
									this.checkInternet();
								}}
								name="videocheck"
							>
								click here
							</span>
						</span>
					</div>

					<div id="restrictReplay">You can view the video only two times.</div>
				</div>
				<div
					className="question-img-desc"
					dangerouslySetInnerHTML={{ __html: queDesc }}
				></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		leftSectionProps: { qtype, questionId, youtubeEnd, youtubeStart },
		isFeedback,
		leftSectionProps,
		elementType,
		prevVideoId,
		rightSectionProps,
		rightSectionProps: { vkDetails },
		currentAttemptId,
	} = state.rootReducer.testPageDetails;

	return {
		leftSectionProps,
		rightSectionProps,
		prevVideoId,
		isFeedback,
		vkDetails,
		currentAttemptId,
		qtype,
		questionId,
		youtubeEnd,
		youtubeStart,
		elementType,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setPrevVideoId: (id) => dispatch(setPrevVideoId(id)),
		setErrorMsg: (msg) => dispatch(setErrorMsg(msg)),
		checkVideo: (currentAttemptId, questionId, videoId) =>
			dispatch(checkVideo(currentAttemptId, questionId, videoId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Video);
